export interface HotEvent {
  id: string;
  title: string;
  category: string;
  status: "fajiao" | "fanzhuan" | "luoding" | "chixu";
  statusText: string;
  heat: number;
  time: string;
  updates: number;
  views: string;
  summary: string;
  tag: string;
  img: string;
  imgAlt: string;
}

export const categories = ["全部", "明星娱乐", "直播圈", "品牌公关", "社会热点", "体育电竞"];

export const hotEvents: HotEvent[] = [
  {
    id: "evt-01",
    title: "顶流剧组天价片酬疑云：从爆料发酵到多方辟谣的七十二小时",
    category: "明星娱乐",
    status: "fanzhuan",
    statusText: "反转中",
    heat: 98,
    time: "12分钟前更新",
    updates: 24,
    views: "632万",
    summary: "业内爆料与制片方回应各执一词，涉事演员工作室两度发声，事件走向出现关键转折。",
    tag: "片酬争议",
    img: "https://readdy.ai/api/search-image?query=warm%20editorial%20documentary%20photo%20about%20a%20trending%20celebrity%20salary%20debate%20in%20china%20media%2C%20newspapers%20and%20smartphone%20screens%20with%20breaking%20news%2C%20amber%20and%20cream%20tones%2C%20soft%20cinematic%20lighting%2C%20high%20detail%2C%20balanced%20composition&width=600&height=400&seq=xingchou-01&orientation=landscape",
    imgAlt: "明星剧组天价片酬争议报道配图",
  },
  {
    id: "evt-02",
    title: "头部带货主播选品翻车，退款风波再迎第三轮证据回应",
    category: "直播圈",
    status: "fajiao",
    statusText: "持续发酵",
    heat: 96,
    time: "26分钟前更新",
    updates: 31,
    views: "518万",
    summary: "质检报告与消费者实录连续流出，供应链上游也开始站队发声，舆论仍在高位盘旋。",
    tag: "选品争议",
    img: "https://readdy.ai/api/search-image?query=warm%20editorial%20documentary%20photo%20of%20product%20quality%20controversy%20during%20live%20streaming%20ecommerce%20in%20china%2C%20packaging%20boxes%20and%20quality%20report%2C%20amber%20cream%20tones%2C%20soft%20lighting%2C%20high%20detail&width=600&height=400&seq=xuanpin-02&orientation=landscape",
    imgAlt: "带货主播选品争议事件持续发酵报道配图",
  },
  {
    id: "evt-03",
    title: "老字号品牌联名翻车后凌晨道歉：从全网群嘲到口碑修复的全过程",
    category: "品牌公关",
    status: "luoding",
    statusText: "已落地",
    heat: 89,
    time: "1小时前更新",
    updates: 18,
    views: "403万",
    summary: "联名文案争议触发舆情，品牌方连夜更换物料并致歉，事件进入复盘阶段。",
    tag: "公关危机",
    img: "https://readdy.ai/api/search-image?query=warm%20editorial%20photo%20of%20brand%20public%20relations%20crisis%20apology%20statement%20on%20a%20desk%20in%20china%2C%20heritage%20brand%20packaging%2C%20amber%20and%20cream%20tones%2C%20soft%20lighting%2C%20high%20detail&width=600&height=400&seq=gongguan-03&orientation=landscape",
    imgAlt: "老字号品牌联名公关危机复盘配图",
  },
  {
    id: "evt-04",
    title: "素人博主晒账单引发电商比价大战，平台下场回应优惠机制",
    category: "社会热点",
    status: "chixu",
    statusText: "跟进中",
    heat: 92,
    time: "40分钟前更新",
    updates: 16,
    views: "486万",
    summary: "一张购物账单意外搅动大促比价话题，多家平台先后发布说明，争议仍在蔓延。",
    tag: "消费维权",
    img: "https://readdy.ai/api/search-image?query=warm%20editorial%20documentary%20photo%20about%20online%20shopping%20price%20comparison%20and%20consumer%20rights%20in%20china%2C%20shopping%20receipts%20and%20laptop%2C%20amber%20cream%20tones%2C%20soft%20lighting%2C%20high%20detail&width=600&height=400&seq=biji-04&orientation=landscape",
    imgAlt: "电商比价大战消费维权热点报道配图",
  },
  {
    id: "evt-05",
    title: "电竞选手转会传闻不断反转，官宣日却迎来惊天大和解",
    category: "体育电竞",
    status: "fanzhuan",
    statusText: "反转中",
    heat: 94,
    time: "2小时前更新",
    updates: 27,
    views: "561万",
    summary: "从离队传闻到粉丝请愿，从声明对峙到握手言和，一场转会大戏跌宕起伏。",
    tag: "转会风波",
    img: "https://readdy.ai/api/search-image?query=warm%20editorial%20documentary%20photo%20about%20esports%20player%20transfer%20drama%20in%20china%2C%20gaming%20setup%20and%20news%20headlines%2C%20amber%20cream%20tones%2C%20soft%20cinematic%20lighting%2C%20high%20detail&width=600&height=400&seq=zhuanghui-05&orientation=landscape",
    imgAlt: "电竞选手转会事件反转报道配图",
  },
  {
    id: "evt-06",
    title: "综艺现场剪辑争议再升级，节目组公开未删减片段回应质疑",
    category: "明星娱乐",
    status: "chixu",
    statusText: "跟进中",
    heat: 85,
    time: "3小时前更新",
    updates: 12,
    views: "347万",
    summary: "观众质疑剪辑引导舆论，节目组放出原始素材自证，评论区仍在拉锯。",
    tag: "剪辑争议",
    img: "https://readdy.ai/api/search-image?query=warm%20editorial%20documentary%20photo%20about%20variety%20show%20editing%20controversy%20in%20china%20tv%2C%20studio%20monitor%20and%20clapperboard%2C%20amber%20cream%20tones%2C%20soft%20lighting%2C%20high%20detail&width=600&height=400&seq=jidian-06&orientation=landscape",
    imgAlt: "综艺剪辑争议事件持续跟进配图",
  },
  {
    id: "evt-07",
    title: "新消费品牌创始人公开信刷屏，一句道歉换来满屏反转",
    category: "品牌公关",
    status: "fajiao",
    statusText: "持续发酵",
    heat: 90,
    time: "4小时前更新",
    updates: 21,
    views: "439万",
    summary: "公开信回应前期质疑，真诚发言反而引爆新话题，网友评价两极分化严重。",
    tag: "创始人发声",
    img: "https://readdy.ai/api/search-image?query=warm%20editorial%20documentary%20photo%20of%20a%20startup%20founder%20open%20letter%20moment%20in%20china%2C%20typed%20letter%20and%20coffee%20on%20desk%2C%20amber%20cream%20tones%2C%20soft%20lighting%2C%20high%20detail&width=600&height=400&seq=gongkai-07&orientation=landscape",
    imgAlt: "新消费品牌创始人公开信事件配图",
  },
  {
    id: "evt-08",
    title: "线下活动踩踏风波背后：主办方与场馆方责任之争进入白热化",
    category: "社会热点",
    status: "fajiao",
    statusText: "持续发酵",
    heat: 93,
    time: "5小时前更新",
    updates: 19,
    views: "472万",
    summary: "多段现场视频对比曝光，安保预案细节成焦点，责任认定仍在拉锯。",
    tag: "活动安全",
    img: "https://readdy.ai/api/search-image?query=warm%20editorial%20documentary%20photo%20about%20crowd%20safety%20incident%20at%20a%20public%20event%20in%20china%2C%20venue%20and%20security%20plan%20documents%2C%20amber%20cream%20tones%2C%20soft%20lighting%2C%20high%20detail&width=600&height=400&seq=huodong-08&orientation=landscape",
    imgAlt: "线下活动踩踏风波责任争议报道配图",
  },
];

export const timelineEvent = {
  title: "「同一件烂尾剧」从停更到复拍：一段跨越八个月的反转纪实",
  kicker: "本台深度复盘 · 反转次数 3",
  tag: "深度追踪",
  heroAlt: "烂尾剧复拍反转纪实深度追踪配图",
  nodes: [
    {
      date: "3月12日",
      phase: "发酵",
      tone: "primary",
      title: "突然停更，全网哗然",
      text: "主演突发声明宣布退出拍摄，剧组次日发文称“因不可抗力暂停”，话题冲上热搜第一，各种猜测甚嚣尘上。",
    },
    {
      date: "4月02日",
      phase: "反转 1",
      tone: "accent",
      title: "资方疑云，主角离场原因成谜",
      text: "有媒体挖出投资方股权变更记录，传闻资金链紧张，主演工作室火速辟谣，事件走向第一次偏转。",
    },
    {
      date: "6月18日",
      phase: "反转 2",
      tone: "accent",
      title: "导演爆料，剧组停摆另有内情",
      text: "导演接受采访透露剧本与档期冲突细节，与先前说法矛盾，粉丝与路人再度展开论战。",
    },
    {
      date: "8月20日",
      phase: "反转 3",
      tone: "accent",
      title: "资本入场，复拍传闻不胫而走",
      text: "新资方官宣注资，原班底陆续回归，官方放出复拍海报，评论区一片“追剧复活”的欢呼。",
    },
    {
      date: "11月06日",
      phase: "落地",
      tone: "secondary",
      title: "正式复拍，尘埃落定",
      text: "开机发布会举行，全员到场释疑，制作方同步公开幕后纪录片企划，这场八个月的追瓜长跑终告一段落。",
    },
  ],
};

export const faqs = [
  {
    q: "爆炸瓜的追瓜节奏是什么样的？",
    a: "我们采用「发酵—反转—落地」三段式追踪：事件一旦开始发酵便第一时间建立专题，后续每次进展、声明或回应都会在 30 分钟内同步更新节点，让你不错过任何关键转折。",
  },
  {
    q: "遇到反转再反转，你们如何保证信息不出错？",
    a: "每条进展都标注来源与时间戳，采用多方交叉核实。对于尚未实锤的内容会明确标注「传闻中」，把事实与观点分开呈现，避免带节奏式误判。",
  },
  {
    q: "我想投稿或提供独家线索，应该怎么联系？",
    a: "在页面下方订阅并勾选「线索投递」，或直接发送线索邮件给我们。所有信息我们都会先核实再发布，并对提供者信息严格保密。",
  },
  {
    q: "追瓜专题会一直保留吗？后续还更新吗？",
    a: "每个已落地的事件会转为「复盘档案」长期保留，方便随时回看完整脉络。仍在发酵的事件会持续更新，直到事件定性或热度自然消退。",
  },
  {
    q: "如何第一时间收到事件的最新进展？",
    a: "订阅爆炸瓜后，重要事件的每次反转我们都会通过邮件第一时间推送给你，订阅是免费且随时可退订的。",
  },
];

export const editorialTabs = [
  {
    key: "all",
    label: "全部精选",
  },
  {
    key: "hot",
    label: "热度最高",
  },
  {
    key: "latest",
    label: "最新进展",
  },
];